import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsTableRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsTableCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { TicketCheckResultsBoard } from "@/lotteries/model/ticket-check/ticket-check";
import { StringUtils } from "@sazka/utils/string-utils";
import { useWagerBoardStore } from "../../stores/use-wager-board-store";

const EMPTY_CELL_STRING = "–––";

export default /*@__PURE__*/_defineComponent({
  __name: 'pp-ticket-check-results-stastne-datum-table',
  props: {
    results: {}
  },
  setup(__props: any) {

const props = __props;
const boardResult = props.results[0];
const wagerStore = useWagerBoardStore();

const getStake = (boardIndex: number) => {
    let stake = wagerStore.boards[boardIndex]?.stake;
    if (wagerStore.multiplier) {
        stake = stake * wagerStore.multiplier;
    }
    return stake;
};

const formatNumberWithCurrency = (amount: number) => {
    if (amount) {
        return StringUtils.formatCurrency(amount);
    }
    return EMPTY_CELL_STRING;
};

const ticketCheckBoard = wagerStore.getBoardsForCheckout;

const formatMatchingPrimaryNumbers = boardResult.matchingPrimary.length
    ? ticketCheckBoard[0].primary[0]
    : EMPTY_CELL_STRING;
const formatMatchingSecondaryNumbers = boardResult.matchingSecondary.length
    ? ticketCheckBoard[0].secondary[0]
    : EMPTY_CELL_STRING;
const formatMatchingTertiaryNumbers = boardResult.matchingTertiary.length
    ? ticketCheckBoard[0].tertiary[0]
    : EMPTY_CELL_STRING;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsTable, {
    "is-scrollable": true,
    "is-responsive": true
  }, {
    default: _withCtx(() => [
      _createVNode(DsTableRow, null, {
        default: _withCtx(() => [
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Uhodnutý den")
            ])),
            _: 1,
            __: [0]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Uhodnutý měsíc")
            ])),
            _: 1,
            __: [1]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Uhodnutý rok")
            ])),
            _: 1,
            __: [2]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Vklad")
            ])),
            _: 1,
            __: [3]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Výhra")
            ])),
            _: 1,
            __: [4]
          })
        ]),
        _: 1
      }),
      (_unref(boardResult))
        ? (_openBlock(), _createBlock(DsTableRow, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(DsTableCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(formatMatchingPrimaryNumbers)), 1)
                ]),
                _: 1
              }),
              _createVNode(DsTableCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(formatMatchingSecondaryNumbers)), 1)
                ]),
                _: 1
              }),
              _createVNode(DsTableCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(formatMatchingTertiaryNumbers)), 1)
                ]),
                _: 1
              }),
              _createVNode(DsTableCell, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: formatNumberWithCurrency(getStake(0))
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }),
              _createVNode(DsTableCell, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: formatNumberWithCurrency(_unref(boardResult).winAmount)
                  }, null, 8, _hoisted_2)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})